const __request = require(`./__request`);
/**
 * 采购商注册
 */
export default function (val) {
  var pParameter = {}
  pParameter.method = "POST"
  pParameter.urlSuffix = "/web/common/userBuyer/new"
  pParameter.data = val
  pParameter.check_token = false;
  return new Promise(function (resolve, reject) {
    resolve(__request(pParameter))
  })
}
